import { z } from "zod";

export { z };

// Role primitives live in their own leaf module so cross-module imports
// (e.g. ./forms.js) don't form a cycle through the barrel.
export * from "./roles.js";

export * from "./overview.js";
export * from "./forms.js";
export * from "./feedback.js";

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Roles
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

// ROLES / RoleSchema / Role / TEAMS / TeamSchema / Team / rolePrivilege /
// hasAtLeast are re-exported from ./roles.js above. Imported here for use
// in the type predicates and schemas defined further down this barrel.
import { ROLES, RoleSchema, type Role } from "./roles.js";

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Forms / status enums
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const FormTypeSchema = z.enum(["loa", "da_appeal", "ia_appeal", "complaint"]);
export type FormType = z.infer<typeof FormTypeSchema>;

export const FormStatusSchema = z.enum(["pending", "reviewed", "closed"]);
export type FormStatus = z.infer<typeof FormStatusSchema>;

export const LoaStatusSchema = z.enum(["pending", "approved", "denied"]);
export type LoaStatus = z.infer<typeof LoaStatusSchema>;

export const CommunityStatusSchema = z.enum([
  "active",
  "inactive",
  "on_loa",
  "suspended",
  "retired",
  "resigned",
  "terminated",
]);
export type CommunityStatus = z.infer<typeof CommunityStatusSchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Member
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

/**
 * Member shape returned by the REST API.
 * Dates are serialised to ISO strings so they survive JSON round-trips.
 */
export const MemberSchema = z.object({
  id: z.number().int(),
  websiteId: z.string().nullable(),
  firstNameLastInitial: z.string().nullable(),
  email: z.string().nullable(),
  pinNumber: z.string().nullable(),
  /** YYYY-MM-DD */
  joinDate: z.string().nullable(),
  primaryDepartment: z.string().nullable(),
  steamHex: z.string().nullable(),
  discordId: z.string().nullable(),
  discordUsername: z.string().nullable(),
  discordAvatarHash: z.string().nullable(),
  /** Server-specific nickname in the main WWRP guild. Synced by alias cron. */
  guildNickname: z.string().nullable(),
  ts3Uid: z.string().nullable(),
  websiteProfileUrl: z.string().nullable(),
  communityStatus: z.string().nullable(),
  communityPosition: z.string().nullable(),
  role: RoleSchema,
  /** Last login IP — only populated when the caller holds development_command. */
  lastLoginIp: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Member = z.infer<typeof MemberSchema>;

export const OnlineMemberSchema = z.object({
  id: z.number().int(),
  firstNameLastInitial: z.string().nullable(),
  role: RoleSchema,
  lastSeenAt: z.string(),
});
export type OnlineMember = z.infer<typeof OnlineMemberSchema>;

export const UserSettingsSchema = z.object({
  discordDmNotificationOptOut: z.boolean(),
});
export type UserSettings = z.infer<typeof UserSettingsSchema>;

export const PatchUserSettingsBodySchema = z
  .object({
    discordDmNotificationOptOut: z.boolean().optional(),
  })
  .refine((o) => o.discordDmNotificationOptOut !== undefined, {
    message: "At least one setting field is required",
  });
export type PatchUserSettingsBody = z.infer<typeof PatchUserSettingsBodySchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// API envelope
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Disciplinary Actions
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

/**
 * Returns true when a DA's actionTaken + timestamp puts it past its
 * expiration window. Used by both API (to gate visibility for non-JA viewers)
 * and the web (for visual styling). Mirrors the historical client-side rule:
 *   - "coaching", "warning", "no action taken" expire after 365 days
 *   - "option 17" expires after 90 days
 *   - all other actions never expire
 */
export function isDaExpired(actionTaken: string | null | undefined, timestampIso: string): boolean {
  if (!actionTaken) return false;
  const action = actionTaken.trim().toLowerCase();
  const isExpirable =
    action === "coaching" ||
    action === "warning" ||
    action === "no action taken" ||
    action === "option 17";
  if (!isExpirable) return false;
  const age = Date.now() - new Date(timestampIso).getTime();
  return action === "option 17" ? age > 90 * 24 * 60 * 60 * 1000 : age > 365 * 24 * 60 * 60 * 1000;
}

/**
 * Full DA record — includes evidence fields. Only served to Staff+.
 */
export const DisciplinaryActionSchema = z.object({
  id: z.number().int(),
  timestamp: z.string(),
  submittedByName: z.string().nullable(),
  submittedByWebsiteId: z.string().nullable(),
  memberName: z.string().nullable(),
  activeDepartmentOrPosition: z.string().nullable(),
  actionTaken: z.string().nullable(),
  incidentNarrative: z.string().nullable(),
  applicableEvidence: z.string().nullable(),
  daRecordingLink: z.string().nullable(),
  rulesViolated: z.string().nullable(),
  actionRecordingLink: z.string().nullable(),
  retiringCallsign: z.string().nullable(),
  retirementReason: z.string().nullable(),
  resignationReason: z.string().nullable(),
  closingNotes: z.string().nullable(),
  dateSubmitting: z.string().nullable(),
  /** Computed server-side: true when this DA is past its expiration window
   * (e.g. coaching/warning > 365 days). Expired DAs are only returned to
   * Junior Administration+ and sort after all non-expired DAs. */
  expired: z.boolean(),
});
export type DisciplinaryAction = z.infer<typeof DisciplinaryActionSchema>;

/**
 * Redacted DA record â€” evidence fields stripped. Served to the member about
 * their own records when they are below Staff.
 */
export const DisciplinaryActionPublicSchema = DisciplinaryActionSchema.omit({
  applicableEvidence: true,
  daRecordingLink: true,
  actionRecordingLink: true,
  incidentNarrative: true,
});
export type DisciplinaryActionPublic = z.infer<typeof DisciplinaryActionPublicSchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// LOA Requests
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const LoaRequestSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  startDate: z.string(),
  endDate: z.string(),
  reason: z.string(),
  status: LoaStatusSchema,
  submittedAt: z.string(),
});
export type LoaRequest = z.infer<typeof LoaRequestSchema>;

export const APPROVAL_REQUEST_TYPES = ["member_update", "da_update"] as const;
export const ApprovalRequestTypeSchema = z.enum(APPROVAL_REQUEST_TYPES);
export type ApprovalRequestType = z.infer<typeof ApprovalRequestTypeSchema>;

export const APPROVAL_REQUEST_STATUSES = ["pending", "approved", "denied"] as const;
export const ApprovalRequestStatusSchema = z.enum(APPROVAL_REQUEST_STATUSES);
export type ApprovalRequestStatus = z.infer<typeof ApprovalRequestStatusSchema>;

// Shared editable member fields for direct PATCH and approval requests.
export const MemberUpdateFieldsSchema = z
  .object({
    websiteId: z.string().max(64).nullable(),
    firstNameLastInitial: z.string().max(128).nullable(),
    email: z.string().email().max(255).nullable(),
    pinNumber: z.string().max(32).nullable(),
    primaryDepartment: z.string().max(128).nullable(),
    steamHex: z.string().max(64).nullable(),
    ts3Uid: z.string().max(128).nullable(),
    websiteProfileUrl: z.string().url().max(512).nullable(),
    communityStatus: z.string().max(64).nullable(),
    communityPosition: z.string().max(128).nullable(),
  })
  .partial();
export type MemberUpdateFields = z.infer<typeof MemberUpdateFieldsSchema>;

export const RequestMemberUpdateBodySchema = MemberUpdateFieldsSchema.extend({
  reason: z.string().max(2000).nullish(),
}).refine(
  (o) => Object.keys(o).some((k) => k !== "reason" && o[k as keyof typeof o] !== undefined),
  { message: "At least one editable field is required." },
);
export type RequestMemberUpdateBody = z.infer<typeof RequestMemberUpdateBodySchema>;

export const RequestDaUpdateBodySchema = z
  .object({
    actionTaken: z.string().min(1).optional(),
    activeDepartmentOrPosition: z.string().nullish(),
    incidentNarrative: z.string().nullish(),
    rulesViolated: z.string().nullish(),
    closingNotes: z.string().nullish(),
    applicableEvidence: z.string().nullish(),
    daRecordingLink: z.string().nullish(),
    actionRecordingLink: z.string().nullish(),
    dateSubmitting: z.string().date().nullish(),
    reason: z.string().max(2000).nullish(),
  })
  .refine(
    (o) => Object.keys(o).some((k) => k !== "reason" && o[k as keyof typeof o] !== undefined),
    { message: "At least one editable field is required." },
  );
export type RequestDaUpdateBody = z.infer<typeof RequestDaUpdateBodySchema>;

export const PendingLoaApprovalSchema = z.object({
  loa: LoaRequestSchema,
  member: z.object({
    id: z.number().int(),
    firstNameLastInitial: z.string().nullable(),
    role: RoleSchema,
  }),
});
export type PendingLoaApproval = z.infer<typeof PendingLoaApprovalSchema>;

const JsonRecordSchema = z.preprocess(
  (value) => {
    if (typeof value !== "string") return value;
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  },
  z.record(z.string(), z.unknown()),
);

const JsonStringArraySchema = z.preprocess((value) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}, z.array(z.string()));

export const ApprovalRequestSchema = z.object({
  id: z.number().int(),
  type: ApprovalRequestTypeSchema,
  status: ApprovalRequestStatusSchema,
  requesterId: z.number().int().nullable(),
  requesterName: z.string().nullable(),
  reviewerId: z.number().int().nullable(),
  reviewerName: z.string().nullable(),
  targetMemberId: z.number().int().nullable(),
  targetMemberName: z.string().nullable(),
  daId: z.number().int().nullable(),
  fields: JsonStringArraySchema,
  beforeData: JsonRecordSchema,
  afterData: JsonRecordSchema,
  reason: z.string().nullable(),
  decisionNote: z.string().nullable(),
  createdAt: z.string(),
  reviewedAt: z.string().nullable(),
});
export type ApprovalRequest = z.infer<typeof ApprovalRequestSchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Audit log
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const AUDIT_ACTIONS = [
  "LOA_SUBMITTED", // member submits own LOA (pending)
  "LOA_CREATED", // staff creates LOA for a member
  "LOA_APPROVED", // staff approves a LOA
  "LOA_DENIED", // staff denies a LOA
  "LOA_ENDED_EARLY", // staff ends an approved LOA early
  "LOA_DELETED", // staff hard-deletes a LOA record
  "DA_ISSUED", // staff issues a DA against a member
  "DA_UPDATED", // junior_administration+ edits a DA record
  "DA_DELETED", // staff hard-deletes a DA record
  "RESTRICTION_ISSUED", // staff issues a restriction against a member
  "RESTRICTION_ENDED_EARLY", // staff ends a restriction early
  "RESTRICTION_DELETED", // staff hard-deletes a restriction record
  "BENEFIT_ISSUED", // staff issues a benefit to a member
  "BENEFIT_ENDED_EARLY", // staff ends a benefit early
  "BENEFIT_DELETED", // staff hard-deletes a benefit record
  "MEMBER_UPDATED", // staff updates member profile fields
  "MEMBER_VIEWED", // staff views a member profile (reads their record)
  "MEMBER_UPDATE_REQUESTED", // SiT+ requests a member profile update for admin approval
  "MEMBER_UPDATE_APPROVED", // administration+ approves a requested member update
  "MEMBER_UPDATE_DENIED", // administration+ denies a requested member update
  "DA_UPDATE_REQUESTED", // SiT+ requests a DA update for JA+ approval
  "DA_UPDATE_APPROVED", // junior_administration+ approves a requested DA update
  "DA_UPDATE_DENIED", // junior_administration+ denies a requested DA update
  "MEMBER_NOTE_CREATED", // staff creates a note on a member's profile
  "MEMBER_NOTE_UPDATED", // staff edits a note on a member's profile
  "MEMBER_NOTE_DELETED", // staff deletes a note on a member's profile
  "DISCORD_GUILDS_VIEWED", // IA / leadership pulls a member's Discord guild list
  "SHEETS_SYNC_TRIGGERED", // admin triggers a manual sheets pull
  // Departments
  "DEPARTMENT_CREATED",
  "DEPARTMENT_UPDATED",
  "DEPARTMENT_DEACTIVATED",
  "DEPT_RANK_CREATED",
  "DEPT_RANK_UPDATED",
  "DEPT_RANK_DELETED",
  "DEPT_SUBDIVISION_CREATED",
  "DEPT_SUBDIVISION_UPDATED",
  "DEPT_SUBDIVISION_DEACTIVATED",
  "DEPT_SUBDIVISION_DELETED",
  "DEPT_MEMBERSHIP_CREATED",
  "DEPT_MEMBERSHIP_UPDATED",
  "DEPT_MEMBERSHIP_DELETED",
  "DEPT_PRIMARY_CHANGED",
  "DEPT_PERMISSION_GRANTED", // raises visibleToRole to head_administration
  "DEPT_PERMISSION_REVOKED", // raises visibleToRole to head_administration
  "DEPT_SUBDIVISION_RANK_CREATED",
  "DEPT_SUBDIVISION_RANK_UPDATED",
  "DEPT_SUBDIVISION_RANK_DELETED",
  // TeamSpeak
  "TS3_ROLE_ADDED", // staff adds a TS3 server group to a member
  "TS3_ROLE_REMOVED", // staff removes a TS3 server group from a member
  // Training & Certifications
  "COURSE_CREATED",
  "COURSE_UPDATED",
  "COURSE_ARCHIVED",
  "CERTIFICATION_CREATED",
  "CERTIFICATION_UPDATED",
  "CERTIFICATION_ISSUED",
  "CERTIFICATION_REVOKED",
  "CERTIFICATION_RENEWED",
  "TRAINING_ENROLLED",
  "TRAINING_COMPLETED",
  "TRAINING_DROPPED",
  "EXAM_SUBMITTED",
  "EXAM_GRADED",
  "TRAINING_SESSION_CREATED",
  "TRAINING_SESSION_UPDATED",
  "TRAINING_SESSION_COMPLETED",
  "TRAINING_SESSION_CANCELLED",
  "PRACTICAL_EVALUATION_SUBMITTED",
  "PRACTICAL_EVALUATION_GRADED",
  "CERT_PREREQUISITE_ADDED",
  "CERT_PREREQUISITE_REMOVED",
  "CERT_PATHWAY_CREATED",
  "CERT_PATHWAY_UPDATED",
  "CERT_PATHWAY_DELETED",
  "CERT_PATHWAY_STEP_ADDED",
  "CERT_PATHWAY_STEP_UPDATED",
  "CERT_PATHWAY_STEP_REMOVED",
  "DEPT_REQUIRED_CERT_ADDED",
  "DEPT_REQUIRED_CERT_REMOVED",
  "COURSE_BLOCK_REORDERED", // admin reorders content blocks within a module
  "CERTIFICATION_RENEWAL_REQUESTED", // member requests renewal of an expiring/expired cert
  // Department overview pages
  "DEPT_OVERVIEW_DRAFT_SAVED", // editor saves the working draft layout
  "DEPT_OVERVIEW_PUBLISHED", // editor promotes the draft to public
  "DEPT_OVERVIEW_DRAFT_DISCARDED", // editor discards the draft (reverts to published)
  "DEPT_OVERVIEW_REVISION_RESTORED", // editor restores a historical revision into the draft
  // Community bulletins
  "BULLETIN_CREATED", // administration+ posts a new community bulletin
  "BULLETIN_UPDATED", // administration+ edits a community bulletin
  "BULLETIN_DELETED", // administration+ deletes a community bulletin
  // Community updates ("What We're Working On")
  "COMMUNITY_UPDATE_CREATED", // administration+ creates a priority/project update
  "COMMUNITY_UPDATE_UPDATED", // administration+ edits a priority/project update
  "COMMUNITY_UPDATE_ARCHIVED", // administration+ archives a priority/project update
  // Sheets sync conflict resolution
  "SHEETS_CONFLICT_RESOLVED", // admin resolves a sheets sync conflict (applied or dismissed)
  // Department forms
  "DEPT_FORM_CREATED", // manage_department holder creates a form
  "DEPT_FORM_UPDATED", // manage_department holder edits a form's fields / audiences / settings
  "DEPT_FORM_DELETED", // manage_department holder deletes a form (cascades responses + files)
  "DEPT_FORM_STATUS_CHANGED", // status transitioned (draft / open / closed)
  "DEPT_FORM_RESPONSE_SUBMITTED", // member submits a form response
  "DEPT_FORM_RESPONSE_EDITED", // member edits their own response (when permitted)
  "DEPT_FORM_RESPONSE_DELETED", // manage_department holder deletes a response
  "DEPT_FORM_FILE_DOWNLOADED", // viewer downloads an uploaded file attachment
  // Live server actions
  "PLAYER_KICKED", // staff kicks a live player from the FiveM server
  "PLAYER_IN_GAME_NOTIFIED", // staff sends an in-game message to a live player
  // Feedback boards
  "FEEDBACK_BOARD_CREATED", // admin creates a feedback board
  "FEEDBACK_BOARD_UPDATED", // admin updates a feedback board
  "FEEDBACK_BOARD_ARCHIVED", // admin archives a feedback board
  "FEEDBACK_POST_CREATED", // member creates a feedback post
  "FEEDBACK_POST_UPDATED", // author or staff edits a feedback post
  "FEEDBACK_POST_DELETED", // author or staff deletes a feedback post
  "FEEDBACK_POST_STATUS_CHANGED", // staff changes post status
  "FEEDBACK_POST_MERGED", // staff merges a post into another
  "FEEDBACK_POST_PINNED", // staff pins or unpins a post
  "FEEDBACK_COMMENT_DELETED", // staff deletes a comment
  "FEEDBACK_POST_UPDATE_POSTED", // staff posts an admin update on a post
] as const;

export const AuditActionSchema = z.enum(AUDIT_ACTIONS);
export type AuditAction = z.infer<typeof AuditActionSchema>;

/**
 * Default visibility for audit log entries when no explicit floor is set.
 * Matches the historical audience of the audit log page (Admin+).
 */
export const DEFAULT_AUDIT_VISIBILITY: Role = "administration";

export const AuditLogSchema = z.object({
  id: z.number().int(),
  actorId: z.number().int().nullable(),
  actorName: z.string().nullable(),
  action: AuditActionSchema,
  targetMemberId: z.number().int().nullable(),
  targetMemberName: z.string().nullable(),
  details: z.record(z.string(), z.unknown()).nullable(),
  /** Minimum hub role required to see this entry on the audit log page. */
  visibleToRole: RoleSchema,
  createdAt: z.string(),
});
export type AuditLog = z.infer<typeof AuditLogSchema>;

// â”€â”€ Write schemas (Staff+ actions) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

/** Body for Staff+ issuing a new DA against a member. */
export const CreateDaBodySchema = z.object({
  actionTaken: z.string().min(1),
  activeDepartmentOrPosition: z.string().nullish(),
  incidentNarrative: z.string().nullish(),
  rulesViolated: z.string().nullish(),
  closingNotes: z.string().nullish(),
  applicableEvidence: z.string().nullish(),
  daRecordingLink: z.string().nullish(),
  actionRecordingLink: z.string().nullish(),
  /** YYYY-MM-DD â€” defaults to today server-side if omitted */
  dateSubmitting: z.string().date().nullish(),
});
export type CreateDaBody = z.infer<typeof CreateDaBodySchema>;
/** Body for Junior Administration+ editing an existing DA. All fields optional. */
export const PatchDaBodySchema = z
  .object({
    actionTaken: z.string().min(1).optional(),
    activeDepartmentOrPosition: z.string().nullish(),
    incidentNarrative: z.string().nullish(),
    rulesViolated: z.string().nullish(),
    closingNotes: z.string().nullish(),
    applicableEvidence: z.string().nullish(),
    daRecordingLink: z.string().nullish(),
    actionRecordingLink: z.string().nullish(),
    dateSubmitting: z.string().date().nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field must be provided." });
export type PatchDaBody = z.infer<typeof PatchDaBodySchema>;
/** Body for Staff+ creating a LOA for a member. */
export const CreateLoaBodySchema = z.object({
  startDate: z.string().date(),
  endDate: z.string().date(),
  reason: z.string().min(1),
  status: LoaStatusSchema.default("pending"),
});
export type CreateLoaBody = z.infer<typeof CreateLoaBodySchema>;

/** Body for Staff+ updating an existing LOA (approve / deny / end early). */
export const PatchLoaBodySchema = z
  .object({
    status: LoaStatusSchema.optional(),
    endDate: z.string().date().optional(),
  })
  .refine((o) => o.status !== undefined || o.endDate !== undefined, {
    message: "At least one of status or endDate is required",
  });
export type PatchLoaBody = z.infer<typeof PatchLoaBodySchema>;

export const ApprovalDecisionBodySchema = z.object({
  status: z.enum(["approved", "denied"]),
  decisionNote: z.string().max(2000).nullish(),
});
export type ApprovalDecisionBody = z.infer<typeof ApprovalDecisionBodySchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Restrictions
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const RestrictionSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  type: z.string(),
  /** YYYY-MM-DD */
  startDate: z.string(),
  /** YYYY-MM-DD */
  expiryDate: z.string(),
  description: z.string(),
  issuedByName: z.string().nullable(),
  issuedById: z.number().int().nullable(),
  createdAt: z.string(),
});
export type Restriction = z.infer<typeof RestrictionSchema>;

export const CreateRestrictionBodySchema = z.object({
  type: z.string().min(1),
  startDate: z.string().date(),
  expiryDate: z.string().date(),
  description: z.string().min(1),
});
export type CreateRestrictionBody = z.infer<typeof CreateRestrictionBodySchema>;

export const PatchRestrictionBodySchema = z.object({
  expiryDate: z.string().date(),
});
export type PatchRestrictionBody = z.infer<typeof PatchRestrictionBodySchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Benefits
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const BenefitSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  type: z.string(),
  /** YYYY-MM-DD */
  startDate: z.string(),
  /** YYYY-MM-DD */
  expiryDate: z.string(),
  description: z.string(),
  issuedByName: z.string().nullable(),
  issuedById: z.number().int().nullable(),
  createdAt: z.string(),
});
export type Benefit = z.infer<typeof BenefitSchema>;

export const CreateBenefitBodySchema = z.object({
  type: z.string().min(1),
  startDate: z.string().date(),
  expiryDate: z.string().date(),
  description: z.string().min(1),
});
export type CreateBenefitBody = z.infer<typeof CreateBenefitBodySchema>;

export const PatchBenefitBodySchema = z.object({
  expiryDate: z.string().date(),
});
export type PatchBenefitBody = z.infer<typeof PatchBenefitBodySchema>;

// ────────────────────────────────────────────────────────────────────────────
// Member notes (staff-internal, role-gated visibility)
// ────────────────────────────────────────────────────────────────────────────

/**
 * A note attached to a member's profile by Staff+.
 *
 * `visibleToRole` is a *minimum* role; any viewer with `hasAtLeast(viewerRole,
 * note.visibleToRole)` may read it. This means Leadership and Head Admin
 * automatically see every note via inheritance — no special-case logic needed.
 *
 * Notes are never returned to the subject member themselves, regardless of
 * their own role.
 */
export const MemberNoteSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  authorId: z.number().int().nullable(),
  authorName: z.string().nullable(),
  /** Author's hub role at the time the note was written. Used for edit/delete gating. */
  authorRoleAtCreation: RoleSchema,
  /** Minimum hub role required to view this note. */
  visibleToRole: RoleSchema,
  body: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type MemberNote = z.infer<typeof MemberNoteSchema>;

export const CreateMemberNoteBodySchema = z.object({
  body: z.string().min(1).max(10_000),
  visibleToRole: RoleSchema,
});
export type CreateMemberNoteBody = z.infer<typeof CreateMemberNoteBodySchema>;

export const PatchMemberNoteBodySchema = z
  .object({
    body: z.string().min(1).max(10_000).optional(),
    visibleToRole: RoleSchema.optional(),
  })
  .refine((o) => o.body !== undefined || o.visibleToRole !== undefined, {
    message: "At least one of body or visibleToRole is required",
  });
export type PatchMemberNoteBody = z.infer<typeof PatchMemberNoteBodySchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Notifications
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

/**
 * Severity controls the visual treatment of a notification (icon + colour).
 */
export const NotificationSeveritySchema = z.enum(["info", "success", "warning", "danger"]);
export type NotificationSeverity = z.infer<typeof NotificationSeveritySchema>;

/**
 * Loose, free-form `type` string. We use a dotted convention (e.g.
 * `loa.pending`, `da.issued`, `system.broadcast`) so consumers can route
 * or filter without the shared package having to know every emitter.
 */
export const NotificationSchema = z.object({
  id: z.number().int(),
  recipientMemberId: z.number().int(),
  type: z.string(),
  severity: NotificationSeveritySchema,
  title: z.string(),
  body: z.string().nullable(),
  link: z.string().nullable(),
  data: z.record(z.string(), z.unknown()).nullable(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
});
export type Notification = z.infer<typeof NotificationSchema>;

// ── Community Bulletins ───────────────────────────────────────────────────────

/**
 * Featured bulletins posted by Administration+ on the community dashboard.
 * Each bulletin may have an expiry datetime after which it auto-hides from
 * regular members (admins continue to see expired ones for management).
 */
export const BulletinSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  body: z.string(),
  severity: NotificationSeveritySchema,
  isPinned: z.boolean(),
  /** Minimum hub role required to view this bulletin. 'applicant' = visible to all. */
  minRole: RoleSchema,
  authorId: z.number().int().nullable(),
  authorName: z.string().nullable(),
  authorRole: RoleSchema.nullable(),
  expiresAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Bulletin = z.infer<typeof BulletinSchema>;

export const CreateBulletinBodySchema = z.object({
  title: z.string().min(1).max(256),
  body: z.string().min(1),
  severity: NotificationSeveritySchema.optional().default("info"),
  isPinned: z.boolean().optional().default(false),
  /** Minimum role required to view this bulletin. Defaults to 'applicant' (everyone). */
  minRole: RoleSchema.optional().default("applicant"),
  /** ISO-8601 datetime string. Omit or null to never expire. */
  expiresAt: z.string().datetime({ offset: true }).nullish(),
});
export type CreateBulletinBody = z.infer<typeof CreateBulletinBodySchema>;

export const PatchBulletinBodySchema = z.object({
  title: z.string().min(1).max(256).optional(),
  body: z.string().min(1).optional(),
  severity: NotificationSeveritySchema.optional(),
  isPinned: z.boolean().optional(),
  minRole: RoleSchema.optional(),
  expiresAt: z.string().datetime({ offset: true }).nullish(),
});
export type PatchBulletinBody = z.infer<typeof PatchBulletinBodySchema>;

// ── Community updates ─────────────────────────────────────────────────────────

export const CommunityUpdateStatusSchema = z.enum(["planned", "in_progress", "completed"]);
export type CommunityUpdateStatus = z.infer<typeof CommunityUpdateStatusSchema>;

export const CommunityUpdateSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  body: z.string(),
  status: CommunityUpdateStatusSchema,
  category: z.string().nullable(),
  displayOrder: z.number().int(),
  authorId: z.number().int().nullable(),
  authorName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CommunityUpdate = z.infer<typeof CommunityUpdateSchema>;

export const CreateCommunityUpdateBodySchema = z.object({
  title: z.string().min(1).max(256),
  body: z.string().min(1),
  status: CommunityUpdateStatusSchema.optional().default("in_progress"),
  category: z.string().max(64).nullish(),
  displayOrder: z.number().int().optional().default(0),
});
export type CreateCommunityUpdateBody = z.infer<typeof CreateCommunityUpdateBodySchema>;

export const PatchCommunityUpdateBodySchema = z.object({
  title: z.string().min(1).max(256).optional(),
  body: z.string().min(1).optional(),
  status: CommunityUpdateStatusSchema.optional(),
  category: z.string().max(64).nullish(),
  displayOrder: z.number().int().optional(),
});
export type PatchCommunityUpdateBody = z.infer<typeof PatchCommunityUpdateBodySchema>;

// ── Playtime leaderboard ──────────────────────────────────────────────────────

export const PlaytimeLeaderboardEntrySchema = z.object({
  memberId: z.number().int().nullable(),
  name: z.string(),
  role: RoleSchema.nullable(),
  fivemMs: z.number(),
  teamspeakMs: z.number(),
  totalMs: z.number(),
});
export type PlaytimeLeaderboardEntry = z.infer<typeof PlaytimeLeaderboardEntrySchema>;

// ── Sheets sync conflict ──────────────────────────────────────────────────────

export const SheetsSyncConflictSchema = z.object({
  id: z.number().int(),
  websiteId: z.string(),
  discordId: z.string().nullable(),
  /** Raw snapshot of the sheet row values at conflict time. */
  sheetData: z.record(z.string(), z.unknown()),
  /** Member currently holding the websiteId, if any. */
  websiteIdMemberId: z.number().int().nullable(),
  websiteIdMemberName: z.string().nullable(),
  /** Member currently holding the discordId, if any. */
  discordIdMemberId: z.number().int().nullable(),
  discordIdMemberName: z.string().nullable(),
  firstSeenAt: z.string(),
  lastSeenAt: z.string(),
  resolvedAt: z.string().nullable(),
  resolvedById: z.number().int().nullable(),
  resolution: z.enum(["applied", "dismissed"]).nullable(),
});
export type SheetsSyncConflict = z.infer<typeof SheetsSyncConflictSchema>;

export const ResolveConflictBodySchema = z.object({
  resolution: z.enum(["applied", "dismissed"]),
});
export type ResolveConflictBody = z.infer<typeof ResolveConflictBodySchema>;

// ─────────────────────────────────────────────────────────────────────────────

export const CommunityStatsSchema = z.object({
  totalMembers: z.number().int().nonnegative(),
  activeMembers: z.number().int().nonnegative(),
  membersInMainDiscord: z.number().int().nonnegative(),
  onlineInHub: z.number().int().nonnegative(),
  activeFivem: z.number().int().nonnegative(),
  activeTeamspeak: z.number().int().nonnegative(),
  activeCombined: z.number().int().nonnegative(),
});
export type CommunityStats = z.infer<typeof CommunityStatsSchema>;

export const DashboardDataSchema = z.object({
  stats: CommunityStatsSchema,
  announcements: z.array(NotificationSchema),
});
export type DashboardData = z.infer<typeof DashboardDataSchema>;

/**
 * Body used by the Admin+ broadcast endpoint. At least one targeting
 * field (`memberIds`, `roles`, `minRole`, or `everyone`) must be set.
 */
export const SendNotificationBodySchema = z
  .object({
    type: z.string().min(1).max(64),
    severity: NotificationSeveritySchema.default("info"),
    title: z.string().min(1).max(255),
    body: z.string().max(2000).nullish(),
    link: z.string().max(512).nullish(),
    data: z.record(z.string(), z.unknown()).nullish(),
    memberIds: z.array(z.number().int().positive()).optional(),
    roles: z.array(RoleSchema).optional(),
    minRole: RoleSchema.optional(),
    everyone: z.boolean().optional(),
  })
  .refine(
    (o) =>
      (o.memberIds && o.memberIds.length > 0) ||
      (o.roles && o.roles.length > 0) ||
      o.minRole !== undefined ||
      o.everyone === true,
    { message: "At least one of memberIds, roles, minRole, or everyone must be provided" },
  );
export type SendNotificationBody = z.infer<typeof SendNotificationBodySchema>;

// ── Hub Permission System ──────────────────────────────────────────────────────

export const HUB_PERMISSION_DEFAULTS = {
  // Audit & admin
  "audit_log.view": "administration",
  "compliance.view": "staff",
  "sheets.trigger_sync": "administration",
  "sheets.view_conflicts": "administration",
  "sheets.resolve_conflicts": "administration",
  "role_mappings.manage": "head_administration",
  "notifications.broadcast": "administration",
  // Members
  "member.view_list": "staff",
  "member.edit": "staff",
  "member.view_pin": "administration",
  "member.view_ip": "development_command",
  // Disciplinary Actions
  "da.view": "staff",
  "da.issue": "staff",
  "da.edit": "junior_administration",
  "da.view_evidence": "staff",
  // LOA
  "loa.create_for_member": "staff",
  "loa.approve": "leadership",
  // Approvals (update requests)
  "da_update.request": "staff_in_training",
  "da_update.review": "leadership",
  "member_update.request": "staff_in_training",
  "member_update.review": "leadership",
  "cert_renewal.request": "applicant",
  "cert_renewal.review": "staff_in_training",
  // Restrictions & Benefits
  "restriction.manage": "staff",
  "benefit.manage": "staff",
  // Staff notes
  "member_note.create": "staff_in_training",
  // Content management
  "bulletin.manage": "administration",
  "community_update.manage": "administration",
  // Departments
  "department.create": "head_administration",
  "department.deactivate": "head_administration",
  // Discord
  "discord.view_member_guilds": "leadership",
  // TeamSpeak
  "teamspeak.view": "staff",
  "teamspeak.manage_roles": "staff",
  // Feedback
  "feedback.manage": "head_administration",
} as const satisfies Record<string, Role>;

export type HubPermissionKey = keyof typeof HUB_PERMISSION_DEFAULTS;
export const HUB_PERMISSION_KEYS = Object.keys(HUB_PERMISSION_DEFAULTS) as HubPermissionKey[];

export const HubPermissionConfigSchema = z.object({
  key: z.string(),
  defaultRole: RoleSchema,
  configuredRole: RoleSchema,
  isOverridden: z.boolean(),
  updatedAt: z.string().nullable(),
  updatedByName: z.string().nullable(),
});
export type HubPermissionConfig = z.infer<typeof HubPermissionConfigSchema>;

export const PatchHubPermissionBodySchema = z.object({
  minRole: RoleSchema,
});
export type PatchHubPermissionBody = z.infer<typeof PatchHubPermissionBodySchema>;

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// API envelope
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const ApiErrorSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  code: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export function apiSuccessSchema<T extends z.ZodTypeAny>(data: T) {
  return z.object({
    success: z.literal(true),
    data,
  });
}

export type ApiSuccess<T> = { success: true; data: T };
export type ApiResponse<T> = ApiSuccess<T> | ApiError;

// ----------------------------------------------------------------------------
// Playtime (sourced from worldwide-bot via internal HTTP API)
// ----------------------------------------------------------------------------

/**
 * Aggregated playtime totals for a single member, sourced from the bot's
 * FiveM and TeamSpeak session tracking. All durations are in milliseconds.
 *
 * The hub never computes these locally — it proxies the bot's
 * `internal/playtime` endpoint and surfaces the result with optional
 * caching. If the bot is unreachable, hub routes return
 * `{ success: false, code: "PLAYTIME_UNAVAILABLE" }`.
 */
export const PlaytimeSummarySchema = z.object({
  fivemMs7d: z.number().int().nonnegative(),
  fivemMs30d: z.number().int().nonnegative(),
  teamspeakMs7d: z.number().int().nonnegative(),
  teamspeakMs30d: z.number().int().nonnegative(),
  totalMs7d: z.number().int().nonnegative(),
  totalMs30d: z.number().int().nonnegative(),
  avgFivemMs: z.number().nonnegative(),
  avgTeamspeakMs: z.number().nonnegative(),
  avgCombinedMs: z.number().nonnegative(),
  longestFivemMs: z.number().int().nonnegative(),
  longestTeamspeakMs: z.number().int().nonnegative(),
  fivemSessionCount: z.number().int().nonnegative(),
  teamspeakSessionCount: z.number().int().nonnegative(),
  activeFivem: z.number().int().nonnegative(),
  activeTeamspeak: z.number().int().nonnegative(),
});
export type PlaytimeSummary = z.infer<typeof PlaytimeSummarySchema>;

/** One day-bucket of playtime, used for 7- or 30-day chart data. */
export const DailyActivityPointSchema = z.object({
  label: z.string(),
  fivemHours: z.number().nonnegative(),
  teamspeakHours: z.number().nonnegative(),
  totalHours: z.number().nonnegative(),
});
export type DailyActivityPoint = z.infer<typeof DailyActivityPointSchema>;

export const PlaytimeResponseSchema = z.object({
  discordId: z.string(),
  /** False when the bot has never recorded a session for this Discord ID. */
  found: z.boolean(),
  summary: PlaytimeSummarySchema,
  daily: z.array(DailyActivityPointSchema),
});
export type PlaytimeResponse = z.infer<typeof PlaytimeResponseSchema>;

// ── Discord guild lookup ─────────────────────────────────────────────────────
//
// Surfaces the data the in-Discord `/cd` command exposes — which servers a
// member shares with the bot, plus their permissions in each. The hub does
// not store this; it proxies the bot's `internal/discord-guilds` endpoint.

export const DiscordGuildEntrySchema = z.object({
  id: z.string(),
  name: z.string(),
  owner: z.boolean(),
  /** Raw bitfield (Discord OAuth permissions field). Coerced to string — Discord historically returned a number, modern API returns a string. */
  permissions: z.coerce.string(),
  /** Human-readable Discord.js permission flag names (e.g. `"ManageMessages"`). */
  permissionNames: z.array(z.string()),
});
export type DiscordGuildEntry = z.infer<typeof DiscordGuildEntrySchema>;

export const DiscordGuildsResponseSchema = z.object({
  discordId: z.string(),
  /** False when the user has never linked Discord with the bot. */
  found: z.boolean(),
  /** True when the target is on the bot-developers exempt list. */
  exempt: z.boolean(),
  /** Null when the lookup could not be completed (no token, exempt, etc.). */
  guilds: z.array(DiscordGuildEntrySchema).nullable(),
});
export type DiscordGuildsResponse = z.infer<typeof DiscordGuildsResponseSchema>;

// ────────────────────────────────────────────────────────────────────────────
// Departments
// ────────────────────────────────────────────────────────────────────────────

/**
 * Department-scoped permissions delegated to specific members. Orthogonal to
 * the global role hierarchy (Head Admin always wins) and to the rank ladder
 * (rank is roleplay identity, permission is admin grant).
 */
export const DEPARTMENT_PERMISSIONS = [
  "manage_department", // edit dept name/description/insignia/category/active
  "manage_subdivisions", // CRUD subdivisions of the dept
  "manage_roster", // add/remove members, edit memberships
  "assign_ranks", // change a member's rank within the dept
  "manage_permissions", // view delegated permissions (grant/revoke is HA-only)
  "approve_transfers", // (reserved for future cross-department transfer flows)
  "department_admin", // grants all of the above for this department (and its subdivisions)
  // Training & certification permissions
  "manage_training", // create/edit/archive courses, tests, and practical evals within the dept
  "manage_certifications", // create/edit/deactivate certification definitions within the dept
  "grade_training", // grade exams, pass/fail practical evals, mark session attendance
  "schedule_training", // create and manage instructor-led training sessions
  // Content & workspace permissions
  "manage_department_content", // create/edit announcements, resources, and landing page content
  "manage_announcements", // create/edit/delete department announcements
] as const;
export const DepartmentPermissionSchema = z.enum(DEPARTMENT_PERMISSIONS);
export type DepartmentPermission = z.infer<typeof DepartmentPermissionSchema>;

/** Status of a member's tenure in a single department. */
export const MEMBERSHIP_STATUSES = ["active", "inactive", "loa", "suspended"] as const;
export const MembershipStatusSchema = z.enum(MEMBERSHIP_STATUSES);
export type MembershipStatus = z.infer<typeof MembershipStatusSchema>;

/** URL-safe slug — lowercase, digits, dashes; 1–64 chars. */
export const SlugSchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "must be lowercase, digits, and dashes only");

// ── Department ─────────────────────────────────────────────────────────────

export const DepartmentSchema = z.object({
  id: z.number().int(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  category: z.string().nullable(),
  insigniaUrl: z.string().nullable(),
  /** Discord role ID in the main WWRP guild for the Unassigned tab. */
  discordRoleId: z.string().nullable(),
  displayOrder: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
/** Narrow base type (no subdivisions). Prefer `Department` for most uses. */
export type DepartmentBase = z.infer<typeof DepartmentSchema>;

export const CreateDepartmentBodySchema = z.object({
  slug: SlugSchema,
  name: z.string().min(1).max(128),
  description: z.string().max(2000).nullish(),
  category: z.string().max(64).nullish(),
  insigniaUrl: z.string().max(512).nullish(),
  displayOrder: z.number().int().nonnegative().optional(),
  isActive: z.boolean().optional(),
});
export type CreateDepartmentBody = z.infer<typeof CreateDepartmentBodySchema>;

export const PatchDepartmentBodySchema = z
  .object({
    slug: SlugSchema.optional(),
    name: z.string().min(1).max(128).optional(),
    description: z.string().max(2000).nullish(),
    category: z.string().max(64).nullish(),
    insigniaUrl: z.string().max(512).nullish(),
    discordRoleId: z.string().max(32).nullish(),
    displayOrder: z.number().int().nonnegative().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentBody = z.infer<typeof PatchDepartmentBodySchema>;

// ── Department Config ──────────────────────────────────────────────────────

/** Tabs that can be toggled on/off per department. */
export const DEPARTMENT_TABS = [
  "overview",
  "roster",
  "ranks",
  "subdivisions",
  "training",
  "certifications",
  "courses",
  "sessions",
  "resources",
  "announcements",
  "analytics",
  "settings",
] as const;
export type DepartmentTab = (typeof DEPARTMENT_TABS)[number];

export const DepartmentConfigSchema = z.object({
  departmentId: z.number().int(),
  /** Set of tab IDs that are enabled; null = all enabled (default). */
  enabledTabs: z.array(z.enum(DEPARTMENT_TABS)).nullable(),
  /** Markdown/HTML hero text displayed on the Overview tab. */
  landingContent: z.string().nullable(),
  /** URL for a custom banner image on the Overview tab. */
  bannerUrl: z.string().nullable(),
  /** Hex colour override for the department header. */
  accentColor: z.string().nullable(),
  /** Short tagline/motto shown on the department card. */
  tagline: z.string().nullable(),
  /** JSON blob of arbitrary widget settings (reserved for future use). */
  widgetConfig: z.record(z.string(), z.unknown()).nullable(),
  updatedAt: z.string(),
});
export type DepartmentConfig = z.infer<typeof DepartmentConfigSchema>;

export const PatchDepartmentConfigBodySchema = z.object({
  enabledTabs: z.array(z.enum(DEPARTMENT_TABS)).nullish(),
  landingContent: z.string().max(50_000).nullish(),
  bannerUrl: z.string().max(512).nullish(),
  accentColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, "must be a hex colour")
    .nullish(),
  tagline: z.string().max(256).nullish(),
  widgetConfig: z.record(z.string(), z.unknown()).nullish(),
});
export type PatchDepartmentConfigBody = z.infer<typeof PatchDepartmentConfigBodySchema>;

// ── Department Announcement ────────────────────────────────────────────────

export const DepartmentAnnouncementSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  title: z.string(),
  body: z.string(),
  isPinned: z.boolean(),
  isPublished: z.boolean(),
  authorId: z.number().int().nullable(),
  authorName: z.string().nullable(),
  publishedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type DepartmentAnnouncement = z.infer<typeof DepartmentAnnouncementSchema>;

export const CreateDepartmentAnnouncementBodySchema = z.object({
  title: z.string().min(1).max(256),
  body: z.string().min(1).max(50_000),
  isPinned: z.boolean().optional(),
  isPublished: z.boolean().optional(),
});
export type CreateDepartmentAnnouncementBody = z.infer<
  typeof CreateDepartmentAnnouncementBodySchema
>;

export const PatchDepartmentAnnouncementBodySchema = z
  .object({
    title: z.string().min(1).max(256).optional(),
    body: z.string().min(1).max(50_000).optional(),
    isPinned: z.boolean().optional(),
    isPublished: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentAnnouncementBody = z.infer<typeof PatchDepartmentAnnouncementBodySchema>;

// ── Department Resource ────────────────────────────────────────────────────

export const DEPARTMENT_RESOURCE_TYPES = [
  "link",
  "document",
  "sop",
  "policy",
  "guide",
  "video",
  "other",
] as const;
export type DepartmentResourceType = (typeof DEPARTMENT_RESOURCE_TYPES)[number];

export const DepartmentResourceSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  subdivisionId: z.number().int().nullable(),
  type: z.enum(DEPARTMENT_RESOURCE_TYPES),
  title: z.string(),
  description: z.string().nullable(),
  url: z.string().nullable(),
  content: z.string().nullable(),
  category: z.string().nullable(),
  displayOrder: z.number().int(),
  isPublished: z.boolean(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type DepartmentResource = z.infer<typeof DepartmentResourceSchema>;

export const CreateDepartmentResourceBodySchema = z.object({
  type: z.enum(DEPARTMENT_RESOURCE_TYPES),
  title: z.string().min(1).max(256),
  description: z.string().max(2000).nullish(),
  url: z.string().max(2048).nullish(),
  content: z.string().max(100_000).nullish(),
  category: z.string().max(64).nullish(),
  subdivisionId: z.number().int().positive().nullish(),
  displayOrder: z.number().int().nonnegative().optional(),
  isPublished: z.boolean().optional(),
});
export type CreateDepartmentResourceBody = z.infer<typeof CreateDepartmentResourceBodySchema>;

export const PatchDepartmentResourceBodySchema = z
  .object({
    type: z.enum(DEPARTMENT_RESOURCE_TYPES).optional(),
    title: z.string().min(1).max(256).optional(),
    description: z.string().max(2000).nullish(),
    url: z.string().max(2048).nullish(),
    content: z.string().max(100_000).nullish(),
    category: z.string().max(64).nullish(),
    subdivisionId: z.number().int().positive().nullish(),
    displayOrder: z.number().int().nonnegative().optional(),
    isPublished: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentResourceBody = z.infer<typeof PatchDepartmentResourceBodySchema>;

// ── Department Rank ────────────────────────────────────────────────────────

export const DepartmentRankSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  /** Higher = more senior. Integer-ordered, gaps allowed. */
  priority: z.number().int(),
  /**
   * Optional community-role equivalent for this rank (e.g. "administration",
   * "senior_staff"). Null = no mapped community role.
   */
  communityRole: z.string().nullable(),
  /**
   * Callsign pattern, e.g. "1D-{n}". Null = no standardised callsign.
   * The "{n}" token is resolved by the service layer.
   */
  callsignTemplate: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type DepartmentRank = z.infer<typeof DepartmentRankSchema>;

export const CreateDepartmentRankBodySchema = z.object({
  name: z.string().min(1).max(128),
  abbreviation: z.string().max(16).nullish(),
  priority: z.number().int().optional(),
  communityRole: z.string().max(64).nullish(),
  callsignTemplate: z.string().max(64).nullish(),
  isActive: z.boolean().optional(),
});
export type CreateDepartmentRankBody = z.infer<typeof CreateDepartmentRankBodySchema>;

export const PatchDepartmentRankBodySchema = z
  .object({
    name: z.string().min(1).max(128).optional(),
    abbreviation: z.string().max(16).nullish(),
    priority: z.number().int().optional(),
    communityRole: z.string().max(64).nullish(),
    callsignTemplate: z.string().max(64).nullish(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentRankBody = z.infer<typeof PatchDepartmentRankBodySchema>;

// ── Department Subdivision ─────────────────────────────────────────────────

export const DepartmentSubdivisionSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  slug: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  logoUrl: z.string().nullable(),
  /** Hex colour for the subdivision badge on the roster (e.g. "#4FC3F7"). */
  color: z.string().nullable(),
  displayOrder: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type DepartmentSubdivision = z.infer<typeof DepartmentSubdivisionSchema>;

// Extend DepartmentSchema here (after DepartmentSubdivisionSchema) to avoid a
// forward-reference — the two schemas are mutually adjacent in the file.
export const DepartmentWithSubsSchema = DepartmentSchema.extend({
  /** Active subdivisions — included on list and detail responses. */
  subdivisions: z.array(DepartmentSubdivisionSchema).optional(),
});
/** Full department type including optional active subdivisions. */
export type Department = z.infer<typeof DepartmentWithSubsSchema>;

export const CreateDepartmentSubdivisionBodySchema = z.object({
  slug: SlugSchema,
  name: z.string().min(1).max(128),
  description: z.string().max(2000).nullish(),
  logoUrl: z.string().max(512).nullish(),
  color: z.string().max(32).nullish(),
  displayOrder: z.number().int().nonnegative().optional(),
  isActive: z.boolean().optional(),
});
export type CreateDepartmentSubdivisionBody = z.infer<typeof CreateDepartmentSubdivisionBodySchema>;

export const PatchDepartmentSubdivisionBodySchema = z
  .object({
    slug: SlugSchema.optional(),
    name: z.string().min(1).max(128).optional(),
    description: z.string().max(2000).nullish(),
    logoUrl: z.string().max(512).nullish(),
    color: z.string().max(32).nullish(),
    displayOrder: z.number().int().nonnegative().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentSubdivisionBody = z.infer<typeof PatchDepartmentSubdivisionBodySchema>;

// ── Department Membership ──────────────────────────────────────────────────

/**
 * A member's membership in a single department. The API returns this with
 * optional inlined summaries of the related department, rank, and
 * subdivisions to avoid N+1 fetches on the client.
 */
export const DepartmentMembershipSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  departmentId: z.number().int(),
  rankId: z.number().int().nullable(),
  isPrimary: z.boolean(),
  status: MembershipStatusSchema,
  /** YYYY-MM-DD */
  joinedAt: z.string().nullable(),
  /** YYYY-MM-DD */
  promotedAt: z.string().nullable(),
  callsign: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  /** Inlined summaries (set by GET endpoints; absent on bare DB rows). */
  department: DepartmentSchema.optional(),
  rank: DepartmentRankSchema.nullable().optional(),
  subdivisions: z.array(DepartmentSubdivisionSchema).optional(),
});
export type DepartmentMembership = z.infer<typeof DepartmentMembershipSchema>;

export const CreateDepartmentMembershipBodySchema = z.object({
  departmentId: z.number().int().positive(),
  rankId: z.number().int().positive().nullish(),
  isPrimary: z.boolean().optional(),
  status: MembershipStatusSchema.optional(),
  joinedAt: z.string().date().nullish(),
  callsign: z.string().max(32).nullish(),
  notes: z.string().max(2000).nullish(),
  /** Optional initial subdivision assignments. */
  subdivisionIds: z.array(z.number().int().positive()).optional(),
  /** Assign to a custom roster group on creation. */
  rosterGroupId: z.number().int().positive().nullish(),
});
export type CreateDepartmentMembershipBody = z.infer<typeof CreateDepartmentMembershipBodySchema>;

export const PatchDepartmentMembershipBodySchema = z
  .object({
    rankId: z.number().int().positive().nullish(),
    isPrimary: z.boolean().optional(),
    status: MembershipStatusSchema.optional(),
    joinedAt: z.string().date().nullish(),
    promotedAt: z.string().date().nullish(),
    callsign: z.string().max(32).nullish(),
    notes: z.string().max(2000).nullish(),
    /** Replaces the full set of subdivisions when provided. */
    subdivisionIds: z.array(z.number().int().positive()).optional(),
    /** Per-subdivision rank assignments. Updates rank_id on the member_subdivisions row for each entry. */
    subdivisionRanks: z
      .array(
        z.object({
          subdivisionId: z.number().int().positive(),
          rankId: z.number().int().positive().nullable(),
        }),
      )
      .optional(),
    /** Assign to a custom roster group. Pass null to clear (auto-group). */
    rosterGroupId: z.number().int().positive().nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchDepartmentMembershipBody = z.infer<typeof PatchDepartmentMembershipBodySchema>;

// ── Department Permission Grant ────────────────────────────────────────────

export const DepartmentPermissionGrantSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  /** Grantee member. Exactly one of memberId / rankId is non-null. */
  memberId: z.number().int().nullable(),
  /** Grantee rank. When set, all holders of this rank inherit the permission. */
  rankId: z.number().int().nullable(),
  permission: DepartmentPermissionSchema,
  grantedById: z.number().int().nullable(),
  grantedByName: z.string().nullable(),
  grantedAt: z.string(),
  expiresAt: z.string().nullable(),
});
export type DepartmentPermissionGrant = z.infer<typeof DepartmentPermissionGrantSchema>;

export const CreateDepartmentPermissionGrantBodySchema = z
  .object({
    memberId: z.number().int().positive().nullish(),
    rankId: z.number().int().positive().nullish(),
    /** One or more permissions to grant in a single operation. */
    permissions: z.array(DepartmentPermissionSchema).min(1),
    /** ISO datetime; null/omitted = no expiry. */
    expiresAt: z.string().datetime().nullish(),
  })
  .refine((o) => (o.memberId != null) !== (o.rankId != null), {
    message: "Exactly one of memberId or rankId must be provided",
  });
export type CreateDepartmentPermissionGrantBody = z.infer<
  typeof CreateDepartmentPermissionGrantBodySchema
>;

// ── Roster ─────────────────────────────────────────────────────────────────

/**
 * A single roster row — the membership plus a thin member summary plus
 * resolved rank and subdivision details. Returned by GET /departments/{id}/roster.
 */
/** Minimal subdivision rank shape embedded in roster entries. Full SubdivisionRankSchema is defined later in this file. */
const RosterSubdivisionRankSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  priority: z.number().int(),
});

export const DepartmentRosterEntrySchema = z.object({
  membershipId: z.number().int(),
  memberId: z.number().int(),
  memberName: z.string().nullable(),
  websiteId: z.string().nullable(),
  discordId: z.string().nullable(),
  discordAvatarHash: z.string().nullable(),
  hubRole: RoleSchema,
  isPrimary: z.boolean(),
  status: MembershipStatusSchema,
  joinedAt: z.string().nullable(),
  promotedAt: z.string().nullable(),
  callsign: z.string().nullable(),
  notes: z.string().nullable(),
  rank: DepartmentRankSchema.nullable(),
  subdivisions: z.array(
    DepartmentSubdivisionSchema.extend({
      /** Rank held within this specific subdivision, or null if none assigned. */
      subdivisionRank: RosterSubdivisionRankSchema.nullable(),
    }),
  ),
  /** Custom roster group this member is assigned to; null = auto-group by community role. */
  rosterGroupId: z.number().int().nullable(),
  /** Manual sort order within the group; null = follow default sort. */
  rosterSortOrder: z.number().int().nullable(),
});
export type DepartmentRosterEntry = z.infer<typeof DepartmentRosterEntrySchema>;

// ── Roster Import Wizard ──────────────────────────────────────────────────

/**
 * Normalized row produced by the web import wizard after column mapping.
 * All fields are optional so wildly different source sheet layouts can still
 * be processed; validation happens in preview/commit routes.
 */
export const RosterImportRowSchema = z.object({
  sourceRow: z.number().int().positive(),
  websiteId: z.string().trim().max(64).nullish(),
  memberName: z.string().trim().max(128).nullish(),
  rankName: z.string().trim().max(128).nullish(),
  status: z.string().trim().max(64).nullish(),
  isPrimary: z.string().trim().max(16).nullish(),
  callsign: z.string().trim().max(32).nullish(),
  joinedAt: z.string().trim().max(32).nullish(),
  promotedAt: z.string().trim().max(32).nullish(),
  notes: z.string().max(2000).nullish(),
});
export type RosterImportRow = z.infer<typeof RosterImportRowSchema>;

export const RosterImportPreviewBodySchema = z.object({
  rows: z.array(RosterImportRowSchema).min(1).max(5000),
});
export type RosterImportPreviewBody = z.infer<typeof RosterImportPreviewBodySchema>;

export const RosterImportPreviewResultRowSchema = z.object({
  sourceRow: z.number().int().positive(),
  input: RosterImportRowSchema,
  member: z
    .object({
      id: z.number().int().positive(),
      name: z.string().nullable(),
      websiteId: z.string().nullable(),
    })
    .nullable(),
  rank: z
    .object({
      id: z.number().int().positive(),
      name: z.string(),
    })
    .nullable(),
  existingMembershipId: z.number().int().positive().nullable(),
  normalizedStatus: MembershipStatusSchema.nullable(),
  normalizedIsPrimary: z.boolean().nullable(),
  normalizedJoinedAt: z.string().nullable(),
  normalizedPromotedAt: z.string().nullable(),
  issues: z.array(z.string()),
  canImport: z.boolean(),
});
export type RosterImportPreviewResultRow = z.infer<typeof RosterImportPreviewResultRowSchema>;

export const RosterImportPreviewResultSchema = z.object({
  rows: z.array(RosterImportPreviewResultRowSchema),
  summary: z.object({
    total: z.number().int().nonnegative(),
    canImport: z.number().int().nonnegative(),
    withIssues: z.number().int().nonnegative(),
    existingMemberships: z.number().int().nonnegative(),
  }),
});
export type RosterImportPreviewResult = z.infer<typeof RosterImportPreviewResultSchema>;

export const CommitRosterImportBodySchema = z.object({
  rows: z.array(RosterImportRowSchema).min(1).max(5000),
  mode: z.enum(["upsert", "create_missing"]).default("upsert"),
});
export type CommitRosterImportBody = z.infer<typeof CommitRosterImportBodySchema>;

export const CommitRosterImportResultSchema = z.object({
  created: z.number().int().nonnegative(),
  updated: z.number().int().nonnegative(),
  skipped: z.number().int().nonnegative(),
  errors: z.array(
    z.object({
      sourceRow: z.number().int().positive(),
      message: z.string(),
    }),
  ),
});
export type CommitRosterImportResult = z.infer<typeof CommitRosterImportResultSchema>;

/** A hub member who holds the department's Discord role but has no formal membership. */
export const UnassignedDeptMemberSchema = z.object({
  memberId: z.number().int(),
  memberName: z.string().nullable(),
  discordId: z.string(),
  hubRole: z.string(),
  websiteId: z.string().nullable(),
});
export type UnassignedDeptMember = z.infer<typeof UnassignedDeptMemberSchema>;

// ── Roster Field Visibility ────────────────────────────────────────────────

/**
 * The roster fields that departments can restrict visibility on.
 */
export const ROSTER_VISIBLE_FIELDS = ["callsign", "joinedAt", "promotedAt", "notes"] as const;
export type RosterVisibleField = (typeof ROSTER_VISIBLE_FIELDS)[number];

export const ROSTER_VISIBILITY_MODES = ["community_role", "dept_rank", "individuals"] as const;
export type RosterVisibilityMode = (typeof ROSTER_VISIBILITY_MODES)[number];

export const RosterVisibilityRuleSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  field: z.enum(ROSTER_VISIBLE_FIELDS),
  visibilityMode: z.enum(ROSTER_VISIBILITY_MODES),
  minCommunityRole: RoleSchema.nullable(),
  minDeptRankId: z.number().int().nullable(),
  allowedMemberIds: z.array(z.number().int()).nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type RosterVisibilityRule = z.infer<typeof RosterVisibilityRuleSchema>;

export const UpsertRosterVisibilityRuleBodySchema = z.object({
  visibilityMode: z.enum(ROSTER_VISIBILITY_MODES),
  minCommunityRole: RoleSchema.nullish(),
  minDeptRankId: z.number().int().positive().nullish(),
  allowedMemberIds: z.array(z.number().int().positive()).min(1).nullish(),
});
export type UpsertRosterVisibilityRuleBody = z.infer<typeof UpsertRosterVisibilityRuleBodySchema>;

// ── Roster Groups ──────────────────────────────────────────────────────────

/**
 * A custom named section/separator on a department roster.
 * When a department has ≥1 group defined, the roster switches from
 * community-role auto-grouping to custom-group mode.
 */
export const RosterGroupRankRulesSchema = z.object({
  deptRankIds: z.array(z.number().int()),
  communityRoles: z.array(z.string()),
});
export type RosterGroupRankRules = z.infer<typeof RosterGroupRankRulesSchema>;

export const RosterGroupSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  name: z.string(),
  color: z.string().nullable(),
  sortOrder: z.number().int(),
  /** Rank/role rules used to auto-bucket members into this group. */
  rankRules: RosterGroupRankRulesSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type RosterGroup = z.infer<typeof RosterGroupSchema>;

export const CreateRosterGroupBodySchema = z.object({
  name: z.string().min(1).max(64),
  color: z.string().max(32).nullish(),
  sortOrder: z.number().int().min(0).nullish(),
});
export type CreateRosterGroupBody = z.infer<typeof CreateRosterGroupBodySchema>;

export const PatchRosterGroupBodySchema = z.object({
  name: z.string().min(1).max(64).optional(),
  color: z.string().max(32).nullish(),
  sortOrder: z.number().int().min(0).optional(),
});
export type PatchRosterGroupBody = z.infer<typeof PatchRosterGroupBodySchema>;

export const SetRosterGroupRankRulesBodySchema = z.object({
  deptRankIds: z.array(z.number().int().positive()),
  communityRoles: z.array(RoleSchema),
});
export type SetRosterGroupRankRulesBody = z.infer<typeof SetRosterGroupRankRulesBodySchema>;

export const BulkRosterSortOrderItemSchema = z.object({
  membershipId: z.number().int().positive(),
  sortOrder: z.number().int(),
  /** Optionally move the member to a different roster group at the same time. */
  rosterGroupId: z.number().int().positive().nullable(),
});

export const BulkRosterSortOrderBodySchema = z.object({
  items: z.array(BulkRosterSortOrderItemSchema).min(1).max(500),
});
export type BulkRosterSortOrderBody = z.infer<typeof BulkRosterSortOrderBodySchema>;

// ────────────────────────────────────────────────────────────────────────────
// Subdivision Permissions
// ────────────────────────────────────────────────────────────────────────────

/**
 * Subdivision-scoped permissions reuse the same permission strings as
 * department permissions. Aliased here so callers can import a distinct
 * symbol if the sets ever need to diverge in a future migration.
 */
export const SUBDIVISION_PERMISSIONS = DEPARTMENT_PERMISSIONS;
export const SubdivisionPermissionSchema = DepartmentPermissionSchema;
export type SubdivisionPermission = DepartmentPermission;

// ────────────────────────────────────────────────────────────────────────────
// Subdivision Ranks
// ────────────────────────────────────────────────────────────────────────────

export const SubdivisionRankSchema = z.object({
  id: z.number().int(),
  subdivisionId: z.number().int(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  /** Higher = more senior. */
  priority: z.number().int(),
  callsignTemplate: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type SubdivisionRank = z.infer<typeof SubdivisionRankSchema>;

export const CreateSubdivisionRankBodySchema = z.object({
  name: z.string().min(1).max(128),
  abbreviation: z.string().max(16).nullish(),
  priority: z.number().int().optional(),
  callsignTemplate: z.string().max(64).nullish(),
  isActive: z.boolean().optional(),
});
export type CreateSubdivisionRankBody = z.infer<typeof CreateSubdivisionRankBodySchema>;

export const PatchSubdivisionRankBodySchema = z
  .object({
    name: z.string().min(1).max(128).optional(),
    abbreviation: z.string().max(16).nullish(),
    priority: z.number().int().optional(),
    callsignTemplate: z.string().max(64).nullish(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchSubdivisionRankBody = z.infer<typeof PatchSubdivisionRankBodySchema>;

// ── Subdivision Permission Grant ───────────────────────────────────────────

export const SubdivisionPermissionGrantSchema = z.object({
  id: z.number().int(),
  subdivisionId: z.number().int(),
  /** Grantee member. Exactly one of memberId / rankId is non-null. */
  memberId: z.number().int().nullable(),
  /** Grantee subdivision rank. Exactly one of memberId / rankId is non-null. */
  rankId: z.number().int().nullable(),
  permission: SubdivisionPermissionSchema,
  grantedById: z.number().int().nullable(),
  grantedByName: z.string().nullable(),
  grantedAt: z.string(),
  expiresAt: z.string().nullable(),
});
export type SubdivisionPermissionGrant = z.infer<typeof SubdivisionPermissionGrantSchema>;

export const CreateSubdivisionPermissionGrantBodySchema = z
  .object({
    memberId: z.number().int().positive().nullish(),
    rankId: z.number().int().positive().nullish(),
    permission: SubdivisionPermissionSchema,
    expiresAt: z.string().datetime().nullish(),
  })
  .refine((o) => (o.memberId != null) !== (o.rankId != null), {
    message: "Exactly one of memberId or rankId must be provided",
  });
export type CreateSubdivisionPermissionGrantBody = z.infer<
  typeof CreateSubdivisionPermissionGrantBodySchema
>;

// ────────────────────────────────────────────────────────────────────────────
// TeamSpeak 3
// ────────────────────────────────────────────────────────────────────────────

/**
 * A TS3 server group as returned by the hub API.
 * type: 0 = template, 1 = regular, 2 = channel admin.
 * Only type=1 groups are exposed in the role management UI.
 */
export const Ts3ServerGroupSchema = z.object({
  sgid: z.number().int(),
  name: z.string(),
  type: z.number().int(),
  /** TS3 sort order (`sortid`) used for display order. Lower numbers come first. */
  sortId: z.number().int(),
  /** Minimum i_group_needed_member_add_power required to assign this group. */
  neededModifyPower: z.number().int(),
});
export type Ts3ServerGroup = z.infer<typeof Ts3ServerGroupSchema>;

/**
 * The caller's TS3 role information — their current groups plus the groups
 * they are permitted to assign to/remove from others.
 */
export const Ts3MemberRolesSchema = z.object({
  /** The member's TS3 UID (mirrors members.ts3Uid). */
  ts3Uid: z.string(),
  /** Server groups currently assigned to this member. */
  groups: z.array(Ts3ServerGroupSchema),
});
export type Ts3MemberRoles = z.infer<typeof Ts3MemberRolesSchema>;

/**
 * Full server-group list response, augmented with which groups the calling
 * staff member is permitted to assign/revoke (based on their own TS3 roles).
 */
export const Ts3ServerGroupsResponseSchema = z.object({
  groups: z.array(Ts3ServerGroupSchema),
  /** sgids the caller can assign/remove on other members. */
  assignableByCallerSgids: z.array(z.number().int()),
});
export type Ts3ServerGroupsResponse = z.infer<typeof Ts3ServerGroupsResponseSchema>;

// ────────────────────────────────────────────────────────────────────────────
// Compliance
// ────────────────────────────────────────────────────────────────────────────

export const ComplianceReasonCodeSchema = z.enum([
  "NO_DEPARTMENT_MEMBERSHIP",
  "NO_PRIMARY_DEPARTMENT",
  "MISSING_COMMUNITY_STATUS",
  "INVALID_COMMUNITY_STATUS",
  "MISSING_COMMUNITY_POSITION",
  "MISSING_DISCORD_ID",
  "MISSING_STEAM_HEX",
  "MISSING_WEBSITE_ID",
  "MISSING_TS3_UID",
  "ACTIVE_NOT_IN_MAIN_DISCORD",
  "MISSING_REQUIRED_CERTIFICATION",
  "EXPIRED_CERTIFICATION",
  "CERTIFICATION_PENDING_RENEWAL",
]);
export type ComplianceReasonCode = z.infer<typeof ComplianceReasonCodeSchema>;

export const ComplianceReasonSchema = z.object({
  code: ComplianceReasonCodeSchema,
  message: z.string(),
});
export type ComplianceReason = z.infer<typeof ComplianceReasonSchema>;

export const ComplianceDepartmentMembershipSchema = z.object({
  membershipId: z.number().int(),
  departmentId: z.number().int(),
  departmentName: z.string(),
  isPrimary: z.boolean(),
});
export type ComplianceDepartmentMembership = z.infer<typeof ComplianceDepartmentMembershipSchema>;

export const NonCompliantMemberSchema = z.object({
  member: MemberSchema,
  inMainDiscord: z.boolean(),
  departmentMemberships: z.array(ComplianceDepartmentMembershipSchema),
  reasons: z.array(ComplianceReasonSchema).min(1),
});
export type NonCompliantMember = z.infer<typeof NonCompliantMemberSchema>;

export const NonCompliantMembersResponseSchema = z.object({
  items: z.array(NonCompliantMemberSchema),
  total: z.number().int(),
  limit: z.number().int(),
  offset: z.number().int(),
});
export type NonCompliantMembersResponse = z.infer<typeof NonCompliantMembersResponseSchema>;

// ────────────────────────────────────────────────────────────────────────────
// Training & Certification System
// ────────────────────────────────────────────────────────────────────────────

// ── Enums ──────────────────────────────────────────────────────────────────

export const TRAINING_COURSE_TYPES = [
  "self_guided",
  "instructor_led",
  "hybrid",
  "practical",
  "written_exam",
  "recertification",
  "orientation",
] as const;
export const TrainingCourseTypeSchema = z.enum(TRAINING_COURSE_TYPES);
export type TrainingCourseType = z.infer<typeof TrainingCourseTypeSchema>;

export const TRAINING_VISIBILITY_MODES = [
  "public",
  "restricted_rank",
  "restricted_subdivision",
  "invite_only",
  "draft",
] as const;
export const TrainingVisibilitySchema = z.enum(TRAINING_VISIBILITY_MODES);
export type TrainingVisibility = z.infer<typeof TrainingVisibilitySchema>;

export const TRAINING_DIFFICULTY_LEVELS = ["beginner", "intermediate", "advanced"] as const;
export const TrainingDifficultySchema = z.enum(TRAINING_DIFFICULTY_LEVELS);
export type TrainingDifficulty = z.infer<typeof TrainingDifficultySchema>;

export const TRAINING_CONTENT_BLOCK_TYPES = [
  "rich_text",
  "markdown",
  "image",
  "video",
  "embed",
  "attachment",
  "link",
  "checklist",
  "quiz",
  "practical_task",
  "instructor_note",
  "scenario_prompt",
] as const;
export const TrainingContentBlockTypeSchema = z.enum(TRAINING_CONTENT_BLOCK_TYPES);
export type TrainingContentBlockType = z.infer<typeof TrainingContentBlockTypeSchema>;

export const TRAINING_ENROLLMENT_STATUSES = [
  "enrolled",
  "in_progress",
  "completed",
  "failed",
  "dropped",
] as const;
export const TrainingEnrollmentStatusSchema = z.enum(TRAINING_ENROLLMENT_STATUSES);
export type TrainingEnrollmentStatus = z.infer<typeof TrainingEnrollmentStatusSchema>;

export const TRAINING_QUESTION_TYPES = [
  "multiple_choice",
  "multi_select",
  "true_false",
  "short_answer",
  "long_answer",
  "scenario",
  "matching",
  "ordering",
] as const;
export const TrainingQuestionTypeSchema = z.enum(TRAINING_QUESTION_TYPES);
export type TrainingQuestionType = z.infer<typeof TrainingQuestionTypeSchema>;

export const TRAINING_ATTEMPT_STATUSES = [
  "in_progress",
  "submitted",
  "graded",
  "passed",
  "failed",
] as const;
export const TrainingAttemptStatusSchema = z.enum(TRAINING_ATTEMPT_STATUSES);
export type TrainingAttemptStatus = z.infer<typeof TrainingAttemptStatusSchema>;

export const TRAINING_SESSION_STATUSES = [
  "scheduled",
  "in_progress",
  "completed",
  "cancelled",
] as const;
export const TrainingSessionStatusSchema = z.enum(TRAINING_SESSION_STATUSES);
export type TrainingSessionStatus = z.infer<typeof TrainingSessionStatusSchema>;

export const TRAINING_ATTENDANCE_STATUSES = [
  "registered",
  "attended",
  "absent",
  "excused",
] as const;
export const TrainingAttendanceStatusSchema = z.enum(TRAINING_ATTENDANCE_STATUSES);
export type TrainingAttendanceStatus = z.infer<typeof TrainingAttendanceStatusSchema>;

export const TRAINING_SESSION_EVAL_STATUSES = [
  "pending",
  "passed",
  "failed",
  "not_applicable",
] as const;
export const TrainingSessionEvalStatusSchema = z.enum(TRAINING_SESSION_EVAL_STATUSES);
export type TrainingSessionEvalStatus = z.infer<typeof TrainingSessionEvalStatusSchema>;

export const CERTIFICATION_STATUSES = ["active", "expired", "revoked", "pending_renewal"] as const;
export const CertificationStatusSchema = z.enum(CERTIFICATION_STATUSES);
export type CertificationStatus = z.infer<typeof CertificationStatusSchema>;

export const PRACTICAL_EVAL_STATUSES = ["pending", "in_progress", "passed", "failed"] as const;
export const PracticalEvalStatusSchema = z.enum(PRACTICAL_EVAL_STATUSES);
export type PracticalEvalStatus = z.infer<typeof PracticalEvalStatusSchema>;

// ── Certifications ─────────────────────────────────────────────────────────

export const TrainingCertificationSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  subdivisionId: z.number().int().nullable(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  icon: z.string().nullable(),
  expiresAfterDays: z.number().int().nullable(),
  isRenewable: z.boolean(),
  requiresReevaluation: z.boolean(),
  isActive: z.boolean(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingCertification = z.infer<typeof TrainingCertificationSchema>;

export const CreateCertificationBodySchema = z.object({
  name: z.string().min(1).max(128),
  abbreviation: z.string().max(16).nullish(),
  description: z.string().max(2000).nullish(),
  color: z.string().max(32).nullish(),
  icon: z.string().max(64).nullish(),
  subdivisionId: z.number().int().positive().nullish(),
  expiresAfterDays: z.number().int().positive().nullish(),
  isRenewable: z.boolean().optional(),
  requiresReevaluation: z.boolean().optional(),
  metadata: z.record(z.string(), z.unknown()).nullish(),
});
export type CreateCertificationBody = z.infer<typeof CreateCertificationBodySchema>;

export const PatchCertificationBodySchema = z
  .object({
    name: z.string().min(1).max(128).optional(),
    abbreviation: z.string().max(16).nullish(),
    description: z.string().max(2000).nullish(),
    color: z.string().max(32).nullish(),
    icon: z.string().max(64).nullish(),
    expiresAfterDays: z.number().int().positive().nullish(),
    isRenewable: z.boolean().optional(),
    requiresReevaluation: z.boolean().optional(),
    isActive: z.boolean().optional(),
    metadata: z.record(z.string(), z.unknown()).nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchCertificationBody = z.infer<typeof PatchCertificationBodySchema>;

export const MemberCertificationSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  certificationId: z.number().int(),
  certification: TrainingCertificationSchema.optional(),
  issuedById: z.number().int().nullable(),
  issuedByName: z.string().nullable(),
  issuedAt: z.string(),
  expiresAt: z.string().nullable(),
  status: CertificationStatusSchema,
  notes: z.string().nullable(),
  revokedById: z.number().int().nullable(),
  revokedByName: z.string().nullable(),
  revokedAt: z.string().nullable(),
  revokedReason: z.string().nullable(),
  courseEnrollmentId: z.number().int().nullable(),
  createdAt: z.string(),
});
export type MemberCertification = z.infer<typeof MemberCertificationSchema>;

export const IssueCertificationBodySchema = z.object({
  certificationId: z.number().int().positive(),
  issuedAt: z.string().datetime().optional(),
  expiresAt: z.string().datetime().nullish(),
  notes: z.string().max(2000).nullish(),
});
export type IssueCertificationBody = z.infer<typeof IssueCertificationBodySchema>;

export const RevokeCertificationBodySchema = z.object({
  revokedReason: z.string().min(1).max(2000),
});
export type RevokeCertificationBody = z.infer<typeof RevokeCertificationBodySchema>;

// ── Bulk issue + renewal ───────────────────────────────────────────────────

export const BulkIssueCertificationBodySchema = z.object({
  memberIds: z.array(z.number().int().positive()).min(1).max(500),
  expiresAt: z.string().datetime().nullish(),
  notes: z.string().max(2000).nullish(),
});
export type BulkIssueCertificationBody = z.infer<typeof BulkIssueCertificationBodySchema>;

export const BulkIssueCertificationResultSchema = z.object({
  issued: z.number().int(),
  skipped: z.array(
    z.object({
      memberId: z.number().int(),
      reason: z.string(),
    }),
  ),
});
export type BulkIssueCertificationResult = z.infer<typeof BulkIssueCertificationResultSchema>;

export const RenewCertificationBodySchema = z.object({
  expiresAt: z.string().datetime(),
  notes: z.string().max(2000).nullish(),
});
export type RenewCertificationBody = z.infer<typeof RenewCertificationBodySchema>;

// ── Certification Prerequisites ────────────────────────────────────────────

export const CertificationPrerequisiteSchema = z.object({
  id: z.number().int(),
  certificationId: z.number().int(),
  requiredCertificationId: z.number().int(),
  requiredCertification: TrainingCertificationSchema.optional(),
  createdAt: z.string(),
});
export type CertificationPrerequisite = z.infer<typeof CertificationPrerequisiteSchema>;

export const CreateCertificationPrerequisiteBodySchema = z.object({
  requiredCertificationId: z.number().int().positive(),
});
export type CreateCertificationPrerequisiteBody = z.infer<
  typeof CreateCertificationPrerequisiteBodySchema
>;

// ── Certification Pathways ─────────────────────────────────────────────────

export const CertificationPathwayStepSchema = z.object({
  id: z.number().int(),
  pathwayId: z.number().int(),
  certificationId: z.number().int(),
  certification: TrainingCertificationSchema.optional(),
  stepOrder: z.number().int(),
  isOptional: z.boolean(),
  createdAt: z.string(),
});
export type CertificationPathwayStep = z.infer<typeof CertificationPathwayStepSchema>;

export const CertificationPathwaySchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  name: z.string(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  icon: z.string().nullable(),
  displayOrder: z.number().int(),
  isActive: z.boolean(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  steps: z.array(CertificationPathwayStepSchema).optional(),
});
export type CertificationPathway = z.infer<typeof CertificationPathwaySchema>;

export const CreateCertificationPathwayBodySchema = z.object({
  name: z.string().min(1).max(128),
  description: z.string().max(2000).nullish(),
  color: z.string().max(32).nullish(),
  icon: z.string().max(64).nullish(),
  displayOrder: z.number().int().optional(),
});
export type CreateCertificationPathwayBody = z.infer<typeof CreateCertificationPathwayBodySchema>;

export const PatchCertificationPathwayBodySchema = z
  .object({
    name: z.string().min(1).max(128).optional(),
    description: z.string().max(2000).nullish(),
    color: z.string().max(32).nullish(),
    icon: z.string().max(64).nullish(),
    displayOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchCertificationPathwayBody = z.infer<typeof PatchCertificationPathwayBodySchema>;

export const CreatePathwayStepBodySchema = z.object({
  certificationId: z.number().int().positive(),
  stepOrder: z.number().int().optional(),
  isOptional: z.boolean().optional(),
});
export type CreatePathwayStepBody = z.infer<typeof CreatePathwayStepBodySchema>;

export const PatchPathwayStepBodySchema = z
  .object({
    stepOrder: z.number().int().optional(),
    isOptional: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchPathwayStepBody = z.infer<typeof PatchPathwayStepBodySchema>;

export const PathwayProgressSchema = z.object({
  pathwayId: z.number().int(),
  completedStepIds: z.array(z.number().int()),
  pendingStepIds: z.array(z.number().int()),
  percentComplete: z.number().int(),
});
export type PathwayProgress = z.infer<typeof PathwayProgressSchema>;

// ── Department Required Certifications ─────────────────────────────────────

export const DepartmentRequiredCertificationSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  certificationId: z.number().int(),
  certification: TrainingCertificationSchema.optional(),
  rankId: z.number().int().nullable(),
  subdivisionId: z.number().int().nullable(),
  isMandatory: z.boolean(),
  notes: z.string().nullable(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
});
export type DepartmentRequiredCertification = z.infer<typeof DepartmentRequiredCertificationSchema>;

export const CreateDepartmentRequiredCertificationBodySchema = z.object({
  certificationId: z.number().int().positive(),
  rankId: z.number().int().positive().nullish(),
  subdivisionId: z.number().int().positive().nullish(),
  isMandatory: z.boolean().optional(),
  notes: z.string().max(1000).nullish(),
});
export type CreateDepartmentRequiredCertificationBody = z.infer<
  typeof CreateDepartmentRequiredCertificationBodySchema
>;

// ── Courses ────────────────────────────────────────────────────────────────

export const TrainingCourseSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  subdivisionId: z.number().int().nullable(),
  title: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  courseType: TrainingCourseTypeSchema,
  visibility: TrainingVisibilitySchema,
  difficulty: TrainingDifficultySchema,
  estimatedDurationMins: z.number().int().nullable(),
  passingScore: z.number().int().nullable(),
  certificationAwardedId: z.number().int().nullable(),
  expiresAfterDays: z.number().int().nullable(),
  requiresInstructorApproval: z.boolean(),
  autoIssueCertification: z.boolean(),
  isActive: z.boolean(),
  isArchived: z.boolean(),
  isPublished: z.boolean(),
  tags: z.array(z.string()).nullable(),
  thumbnailUrl: z.string().nullable(),
  bannerUrl: z.string().nullable(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  updatedById: z.number().int().nullable(),
  updatedByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  moduleCount: z.number().int().optional(),
  enrolledCount: z.number().int().optional(),
});
export type TrainingCourse = z.infer<typeof TrainingCourseSchema>;

export const CreateCourseBodySchema = z.object({
  title: z.string().min(1).max(255),
  slug: SlugSchema,
  description: z.string().max(5000).nullish(),
  courseType: TrainingCourseTypeSchema.optional(),
  visibility: TrainingVisibilitySchema.optional(),
  difficulty: TrainingDifficultySchema.optional(),
  subdivisionId: z.number().int().positive().nullish(),
  estimatedDurationMins: z.number().int().positive().nullish(),
  passingScore: z.number().int().min(0).max(100).nullish(),
  certificationAwardedId: z.number().int().positive().nullish(),
  expiresAfterDays: z.number().int().positive().nullish(),
  requiresInstructorApproval: z.boolean().optional(),
  autoIssueCertification: z.boolean().optional(),
  tags: z.array(z.string().max(64)).max(20).nullish(),
  thumbnailUrl: z.string().url().max(512).nullish(),
  bannerUrl: z.string().url().max(512).nullish(),
});
export type CreateCourseBody = z.infer<typeof CreateCourseBodySchema>;

export const PatchCourseBodySchema = z
  .object({
    title: z.string().min(1).max(255).optional(),
    slug: SlugSchema.optional(),
    description: z.string().max(5000).nullish(),
    courseType: TrainingCourseTypeSchema.optional(),
    visibility: TrainingVisibilitySchema.optional(),
    difficulty: TrainingDifficultySchema.optional(),
    estimatedDurationMins: z.number().int().positive().nullish(),
    passingScore: z.number().int().min(0).max(100).nullish(),
    certificationAwardedId: z.number().int().positive().nullish(),
    expiresAfterDays: z.number().int().positive().nullish(),
    requiresInstructorApproval: z.boolean().optional(),
    autoIssueCertification: z.boolean().optional(),
    isActive: z.boolean().optional(),
    isPublished: z.boolean().optional(),
    tags: z.array(z.string().max(64)).max(20).nullish(),
    thumbnailUrl: z.string().url().max(512).nullish(),
    bannerUrl: z.string().url().max(512).nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchCourseBody = z.infer<typeof PatchCourseBodySchema>;

// ── Course Modules ─────────────────────────────────────────────────────────

export const TrainingContentBlockSchema: z.ZodType<{
  id: number;
  moduleId: number;
  blockType: TrainingContentBlockType;
  title: string | null;
  content: Record<string, unknown> | null;
  orderIndex: number;
  isRequired: boolean;
  minTimeSeconds: number;
  createdAt: string;
  updatedAt: string;
}> = z.object({
  id: z.number().int(),
  moduleId: z.number().int(),
  blockType: TrainingContentBlockTypeSchema,
  title: z.string().nullable(),
  content: z.record(z.string(), z.unknown()).nullable(),
  orderIndex: z.number().int(),
  isRequired: z.boolean(),
  minTimeSeconds: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingContentBlock = z.infer<typeof TrainingContentBlockSchema>;

export const TrainingCourseModuleSchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  title: z.string(),
  description: z.string().nullable(),
  orderIndex: z.number().int(),
  isRequired: z.boolean(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contentBlocks: z.array(TrainingContentBlockSchema).optional(),
});
export type TrainingCourseModule = z.infer<typeof TrainingCourseModuleSchema>;

export const CreateCourseModuleBodySchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().max(2000).nullish(),
  orderIndex: z.number().int().min(0).optional(),
  isRequired: z.boolean().optional(),
});
export type CreateCourseModuleBody = z.infer<typeof CreateCourseModuleBodySchema>;

export const PatchCourseModuleBodySchema = z
  .object({
    title: z.string().min(1).max(255).optional(),
    description: z.string().max(2000).nullish(),
    orderIndex: z.number().int().min(0).optional(),
    isRequired: z.boolean().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchCourseModuleBody = z.infer<typeof PatchCourseModuleBodySchema>;

// ── Content Blocks ─────────────────────────────────────────────────────────

export const CreateContentBlockBodySchema = z.object({
  blockType: TrainingContentBlockTypeSchema,
  title: z.string().max(255).nullish(),
  content: z.record(z.string(), z.unknown()).nullish(),
  orderIndex: z.number().int().min(0).optional(),
  isRequired: z.boolean().optional(),
  minTimeSeconds: z.number().int().min(0).optional(),
});
export type CreateContentBlockBody = z.infer<typeof CreateContentBlockBodySchema>;

export const PatchContentBlockBodySchema = z
  .object({
    title: z.string().max(255).nullish(),
    content: z.record(z.string(), z.unknown()).nullish(),
    orderIndex: z.number().int().min(0).optional(),
    isRequired: z.boolean().optional(),
    minTimeSeconds: z.number().int().min(0).optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchContentBlockBody = z.infer<typeof PatchContentBlockBodySchema>;

export const ReorderModulesBodySchema = z.object({
  order: z
    .array(z.object({ id: z.number().int().positive(), orderIndex: z.number().int().min(0) }))
    .min(1),
});
export type ReorderModulesBody = z.infer<typeof ReorderModulesBodySchema>;

export const ReorderContentBlocksBodySchema = z.object({
  blockIds: z.array(z.number().int().positive()).min(1),
});
export type ReorderContentBlocksBody = z.infer<typeof ReorderContentBlocksBodySchema>;

// ── Enrollments ────────────────────────────────────────────────────────────

export const TrainingEnrollmentSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  courseId: z.number().int(),
  course: TrainingCourseSchema.optional(),
  enrolledById: z.number().int().nullable(),
  enrolledByName: z.string().nullable(),
  status: TrainingEnrollmentStatusSchema,
  enrolledAt: z.string(),
  startedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  score: z.number().nullable(),
  passed: z.boolean().nullable(),
  instructorId: z.number().int().nullable(),
  instructorName: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingEnrollment = z.infer<typeof TrainingEnrollmentSchema>;

export const CreateEnrollmentBodySchema = z.object({
  memberId: z.number().int().positive(),
  notes: z.string().max(2000).nullish(),
});
export type CreateEnrollmentBody = z.infer<typeof CreateEnrollmentBodySchema>;

export const PatchEnrollmentBodySchema = z
  .object({
    status: TrainingEnrollmentStatusSchema.optional(),
    score: z.number().min(0).max(100).nullish(),
    passed: z.boolean().nullish(),
    instructorId: z.number().int().positive().nullish(),
    notes: z.string().max(2000).nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchEnrollmentBody = z.infer<typeof PatchEnrollmentBodySchema>;

export const TrainingModuleProgressSchema = z.object({
  id: z.number().int(),
  enrollmentId: z.number().int(),
  moduleId: z.number().int(),
  status: z.enum(["not_started", "in_progress", "completed"]),
  completedAt: z.string().nullable(),
  timeSpentSeconds: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingModuleProgress = z.infer<typeof TrainingModuleProgressSchema>;

// ── Tests ──────────────────────────────────────────────────────────────────

export const TrainingTestSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  courseId: z.number().int().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  passingScore: z.number().int(),
  timeLimitMinutes: z.number().int().nullable(),
  maxAttempts: z.number().int().nullable(),
  retakeCooldownHours: z.number().int().nullable(),
  randomizeQuestions: z.boolean(),
  questionCount: z.number().int().nullable(),
  isActive: z.boolean(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  totalQuestions: z.number().int().optional(),
});
export type TrainingTest = z.infer<typeof TrainingTestSchema>;

export const CreateTestBodySchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().max(2000).nullish(),
  courseId: z.number().int().positive().nullish(),
  passingScore: z.number().int().min(0).max(100).optional(),
  timeLimitMinutes: z.number().int().positive().nullish(),
  maxAttempts: z.number().int().positive().nullish(),
  retakeCooldownHours: z.number().int().min(0).nullish(),
  randomizeQuestions: z.boolean().optional(),
  questionCount: z.number().int().positive().nullish(),
});
export type CreateTestBody = z.infer<typeof CreateTestBodySchema>;

export const PatchTestBodySchema = z
  .object({
    title: z.string().min(1).max(255).optional(),
    description: z.string().max(2000).nullish(),
    passingScore: z.number().int().min(0).max(100).optional(),
    timeLimitMinutes: z.number().int().positive().nullish(),
    maxAttempts: z.number().int().positive().nullish(),
    retakeCooldownHours: z.number().int().min(0).nullish(),
    randomizeQuestions: z.boolean().optional(),
    questionCount: z.number().int().positive().nullish(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchTestBody = z.infer<typeof PatchTestBodySchema>;

export const TrainingTestQuestionSchema = z.object({
  id: z.number().int(),
  testId: z.number().int(),
  questionType: TrainingQuestionTypeSchema,
  questionText: z.string(),
  options: z.unknown().nullable(),
  correctAnswer: z.unknown().nullable(),
  explanation: z.string().nullable(),
  points: z.number().int(),
  orderIndex: z.number().int(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingTestQuestion = z.infer<typeof TrainingTestQuestionSchema>;

export const CreateTestQuestionBodySchema = z.object({
  questionType: TrainingQuestionTypeSchema,
  questionText: z.string().min(1).max(5000),
  options: z.unknown().nullish(),
  correctAnswer: z.unknown().nullish(),
  explanation: z.string().max(2000).nullish(),
  points: z.number().int().positive().optional(),
  orderIndex: z.number().int().min(0).optional(),
});
export type CreateTestQuestionBody = z.infer<typeof CreateTestQuestionBodySchema>;

export const PatchTestQuestionBodySchema = z
  .object({
    questionType: TrainingQuestionTypeSchema.optional(),
    questionText: z.string().min(1).max(5000).optional(),
    options: z.unknown().nullish(),
    correctAnswer: z.unknown().nullish(),
    explanation: z.string().max(2000).nullish(),
    points: z.number().int().positive().optional(),
    orderIndex: z.number().int().min(0).optional(),
    isActive: z.boolean().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchTestQuestionBody = z.infer<typeof PatchTestQuestionBodySchema>;

export const TrainingTestAttemptSchema = z.object({
  id: z.number().int(),
  testId: z.number().int(),
  memberId: z.number().int(),
  enrollmentId: z.number().int().nullable(),
  status: TrainingAttemptStatusSchema,
  score: z.number().nullable(),
  passed: z.boolean().nullable(),
  startedAt: z.string(),
  submittedAt: z.string().nullable(),
  gradedAt: z.string().nullable(),
  gradedById: z.number().int().nullable(),
  gradedByName: z.string().nullable(),
  instructorNotes: z.string().nullable(),
  answers: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.string(),
});
export type TrainingTestAttempt = z.infer<typeof TrainingTestAttemptSchema>;

export const SubmitTestAttemptBodySchema = z.object({
  answers: z.record(z.string(), z.unknown()),
});
export type SubmitTestAttemptBody = z.infer<typeof SubmitTestAttemptBodySchema>;

export const GradeTestAttemptBodySchema = z.object({
  score: z.number().min(0).max(100),
  passed: z.boolean(),
  instructorNotes: z.string().max(5000).nullish(),
});
export type GradeTestAttemptBody = z.infer<typeof GradeTestAttemptBodySchema>;

// ── Training Sessions ──────────────────────────────────────────────────────

export const TrainingSessionSchema = z.object({
  id: z.number().int(),
  departmentId: z.number().int(),
  courseId: z.number().int().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  instructorId: z.number().int().nullable(),
  instructorName: z.string().nullable(),
  scheduledAt: z.string(),
  endsAt: z.string().nullable(),
  location: z.string().nullable(),
  maxAttendees: z.number().int().nullable(),
  status: TrainingSessionStatusSchema,
  notes: z.string().nullable(),
  createdById: z.number().int().nullable(),
  createdByName: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  attendeeCount: z.number().int().optional(),
});
export type TrainingSession = z.infer<typeof TrainingSessionSchema>;

export const CreateTrainingSessionBodySchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().max(2000).nullish(),
  courseId: z.number().int().positive().nullish(),
  instructorId: z.number().int().positive().nullish(),
  scheduledAt: z.string().datetime(),
  endsAt: z.string().datetime().nullish(),
  location: z.string().max(255).nullish(),
  maxAttendees: z.number().int().positive().nullish(),
  notes: z.string().max(2000).nullish(),
});
export type CreateTrainingSessionBody = z.infer<typeof CreateTrainingSessionBodySchema>;

export const PatchTrainingSessionBodySchema = z
  .object({
    title: z.string().min(1).max(255).optional(),
    description: z.string().max(2000).nullish(),
    instructorId: z.number().int().positive().nullish(),
    scheduledAt: z.string().datetime().optional(),
    endsAt: z.string().datetime().nullish(),
    location: z.string().max(255).nullish(),
    maxAttendees: z.number().int().positive().nullish(),
    status: TrainingSessionStatusSchema.optional(),
    notes: z.string().max(2000).nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchTrainingSessionBody = z.infer<typeof PatchTrainingSessionBodySchema>;

export const TrainingSessionAttendeeSchema = z.object({
  id: z.number().int(),
  sessionId: z.number().int(),
  memberId: z.number().int(),
  memberName: z.string().nullable(),
  attendanceStatus: TrainingAttendanceStatusSchema,
  evaluationStatus: TrainingSessionEvalStatusSchema,
  score: z.number().nullable(),
  notes: z.string().nullable(),
  evaluatedById: z.number().int().nullable(),
  evaluatedByName: z.string().nullable(),
  evaluatedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TrainingSessionAttendee = z.infer<typeof TrainingSessionAttendeeSchema>;

export const RegisterSessionAttendeeBodySchema = z.object({
  memberIds: z.array(z.number().int().positive()).min(1).max(200),
});
export type RegisterSessionAttendeeBody = z.infer<typeof RegisterSessionAttendeeBodySchema>;

export const PatchSessionAttendeeBodySchema = z
  .object({
    attendanceStatus: TrainingAttendanceStatusSchema.optional(),
    evaluationStatus: TrainingSessionEvalStatusSchema.optional(),
    score: z.number().min(0).max(100).nullish(),
    notes: z.string().max(2000).nullish(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: "At least one field is required" });
export type PatchSessionAttendeeBody = z.infer<typeof PatchSessionAttendeeBodySchema>;

// ── Practical Evaluations ──────────────────────────────────────────────────

export const PracticalEvaluationCriteriaSchema = z.object({
  id: z.number().int(),
  evaluationId: z.number().int(),
  criteriaName: z.string(),
  description: z.string().nullable(),
  passed: z.boolean().nullable(),
  score: z.number().nullable(),
  maxScore: z.number(),
  evaluatorNotes: z.string().nullable(),
  orderIndex: z.number().int(),
});
export type PracticalEvaluationCriteria = z.infer<typeof PracticalEvaluationCriteriaSchema>;

export const PracticalEvaluationSchema = z.object({
  id: z.number().int(),
  memberId: z.number().int(),
  departmentId: z.number().int(),
  courseId: z.number().int().nullable(),
  enrollmentId: z.number().int().nullable(),
  evaluatorId: z.number().int(),
  evaluatorName: z.string().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  status: PracticalEvalStatusSchema,
  overallPassed: z.boolean().nullable(),
  notes: z.string().nullable(),
  evaluatedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  criteria: z.array(PracticalEvaluationCriteriaSchema).optional(),
});
export type PracticalEvaluation = z.infer<typeof PracticalEvaluationSchema>;

export const CreatePracticalEvaluationBodySchema = z.object({
  memberId: z.number().int().positive(),
  courseId: z.number().int().positive().nullish(),
  enrollmentId: z.number().int().positive().nullish(),
  title: z.string().min(1).max(255),
  description: z.string().max(2000).nullish(),
  criteria: z
    .array(
      z.object({
        criteriaName: z.string().min(1).max(255),
        description: z.string().max(1000).nullish(),
        maxScore: z.number().min(0).optional(),
        orderIndex: z.number().int().min(0).optional(),
      }),
    )
    .min(1)
    .max(50),
});
export type CreatePracticalEvaluationBody = z.infer<typeof CreatePracticalEvaluationBodySchema>;

export const SubmitPracticalEvaluationBodySchema = z.object({
  overallPassed: z.boolean(),
  notes: z.string().max(5000).nullish(),
  criteria: z.array(
    z.object({
      id: z.number().int().positive(),
      passed: z.boolean().nullable(),
      score: z.number().min(0).nullish(),
      evaluatorNotes: z.string().max(1000).nullish(),
    }),
  ),
});
export type SubmitPracticalEvaluationBody = z.infer<typeof SubmitPracticalEvaluationBodySchema>;

// ── Training Profile (member profile summary) ──────────────────────────────

export const TrainingProfileSchema = z.object({
  memberId: z.number().int(),
  activeCertifications: z.array(MemberCertificationSchema),
  expiredCertifications: z.array(MemberCertificationSchema),
  enrollments: z.array(TrainingEnrollmentSchema),
  completedCount: z.number().int(),
  inProgressCount: z.number().int(),
  failedCount: z.number().int(),
});
export type TrainingProfile = z.infer<typeof TrainingProfileSchema>;

// ── Live server player tracking ─────────────────────────────────────────────

export const LivePlayerSchema = z.object({
  sessionId: z.string(),
  serverIdentifier: z.string(),
  source: z.number().int().nullable(),
  playerName: z.string(),
  discordId: z.string().nullable(),
  steamHex: z.string().nullable(),
  characterName: z.string().nullable(),
  department: z.string().nullable(),
  connectedAt: z.string(),
  // These three are added by the hub API after member lookup — absent from the
  // raw bot response, so .default(null) coerces undefined → null at parse time.
  linkedMemberId: z.number().int().nullable().default(null),
  linkedMemberName: z.string().nullable().default(null),
  linkedMemberWebsiteId: z.string().nullable().default(null),
});
export type LivePlayer = z.infer<typeof LivePlayerSchema>;

export const ActivePlayersResponseSchema = z.object({
  players: z.array(LivePlayerSchema),
  count: z.number().int(),
  serverCount: z.number().int(),
  servers: z.array(z.string()),
});
export type ActivePlayersResponse = z.infer<typeof ActivePlayersResponseSchema>;

export const KickPlayerBodySchema = z.object({
  serverIdentifier: z.string().min(1),
  source: z.number().int().positive(),
  reason: z.string().min(1).max(200),
  linkedMemberId: z.number().int().positive().nullable().optional(),
});
export type KickPlayerBody = z.infer<typeof KickPlayerBodySchema>;

export const NotifyPlayerBodySchema = z.object({
  serverIdentifier: z.string().min(1),
  source: z.number().int().positive(),
  message: z.string().min(1).max(500),
  linkedMemberId: z.number().int().positive().nullable().optional(),
  sendHubNotification: z.boolean().optional().default(true),
  sendInGameMessage: z.boolean().optional().default(true),
});
export type NotifyPlayerBody = z.infer<typeof NotifyPlayerBodySchema>;
